module.exports = __webpack_public_path__ + "static/img/picture_2.bba90a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/picture_2.png
// module id = m/s+
// module chunks = 0